import { render } from "./CartPopupComponent.vue?vue&type=template&id=5491d2aa&scoped=true"
import script from "./CartPopupComponent.vue?vue&type=script&lang=js"
export * from "./CartPopupComponent.vue?vue&type=script&lang=js"

import "./CartPopupComponent.vue?vue&type=style&index=0&id=5491d2aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5491d2aa"]])

export default __exports__